import { Map } from 'immutable';

import { setPhotosErrors } from '../product/errors';

import { ERROR, OPERATIONS, VALUE } from '../../constants/product';
import { ATTRIBUTE } from '../../constants/attributes';
import { FORM } from '../../constants/forms';

export function editPhotos({ product: source, value }) {
  let product = source;
  const channel = product.get('channel');

  product = setPhotosErrors({ product: product.setIn([FORM.PHOTOS, VALUE], value) });

  if (product.hasIn([ERROR, ATTRIBUTE.PHOTOS])) return { product, operations: [] };

  return { product, operations: [Map({ type: OPERATIONS[channel].PHOTOS.CHANGE_TO, value })] };
}
